import {Directive, EventEmitter, Output, OnInit} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[formControlName][phone]',
  host: {
    '(ngModelChange)': 'onInputChange($event)',
    '(keydown.backspace)': 'onInputChange($event.target.value, true)'
  }
})
export class PhoneDirective implements OnInit {

  @Output()
  rawChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(public model: NgControl) {
  }

    ngOnInit(){
        let newVal = '';
        newVal = this.model.value.replace(/\D/g, '');

        const rawValue = newVal;

    if (0 === newVal.length) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, '($1)');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    } else {
      newVal = newVal.substring(0, newVal.length - 1).replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }

    this.model.valueAccessor.writeValue(newVal);
    this.rawChange.emit(rawValue);
    }

  onInputChange(event, backspace) {
    // remove all mask characters (keep only numeric)
    let newVal = '';
    if (event != null) {
      newVal = event.replace(/\D/g, '');
    }


    const rawValue = newVal;
    // special handling of backspace necessary otherwise
    // deleting of non-numeric characters is not recognized
    // this laves room for improvment for example if you delete in the
    // middle of the string
    if (backspace) {
      if (3 >= newVal.length) {
        newVal = newVal.substring(0, newVal.length - 1);
      } else {
        newVal = newVal.substring(0, newVal.length);
      }
    }

    if (0 === newVal.length) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, '($1)');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    } else {
      newVal = newVal.substring(0, newVal.length - 1).replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }

    // set the new value
    this.model.valueAccessor.writeValue(newVal);
    this.rawChange.emit(rawValue);
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/directives/phone.directive.ts